import { render, staticRenderFns } from "./new-material-app.vue?vue&type=template&id=f284fe68&"
import script from "./new-material-app.vue?vue&type=script&lang=js&"
export * from "./new-material-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f284fe68')) {
      api.createRecord('f284fe68', component.options)
    } else {
      api.reload('f284fe68', component.options)
    }
    module.hot.accept("./new-material-app.vue?vue&type=template&id=f284fe68&", function () {
      api.rerender('f284fe68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/AddMaterialAppComponent/new-material-app.vue"
export default component.exports